import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api, USER_TOKEN_KEY } from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  // null = checking, false = logged out, object = user
  const [user, setUser] = useState(null);

  useEffect(() => {
    if (!localStorage.getItem(USER_TOKEN_KEY)) { setUser(false); return; }
    api.get("/auth/me").then(({ data }) => setUser(data)).catch(() => {
      localStorage.removeItem(USER_TOKEN_KEY);
      setUser(false);
    });
  }, []);

  const signIn = useCallback(({ token, user: u }) => {
    localStorage.setItem(USER_TOKEN_KEY, token);
    setUser(u);
  }, []);

  const signOut = useCallback(() => {
    localStorage.removeItem(USER_TOKEN_KEY);
    setUser(false);
  }, []);

  return <AuthCtx.Provider value={{ user, setUser, signIn, signOut }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
